import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectReducedText, selectHideDecreasedPriceIcons, selectAppContainerId, selectStockMessageContainerId } from "../store/orderingSlice";

export function StyleItemButton({ children, className, onClick, onChange, styleItem, styleRef}) {
  const reduced_text = useSelector(selectReducedText);
  const hide_descreased_price_icons = useSelector(selectHideDecreasedPriceIcons);
  const app_container_id = useSelector(selectAppContainerId);
  const stock_message_container_id = useSelector(selectStockMessageContainerId);
  const input_aria_described_by_id = app_container_id + styleItem.style_item_ref;
  let price_decreased_text = ""
  if (styleItem.selection_is_reduced) {
    price_decreased_text = reduced_text;
  } else if (styleItem.selection_is_closeout) {
    price_decreased_text = "Clearance";
  } else if (styleItem.selection_is_sale) {
    price_decreased_text = "Sale";
  }
  const price_descreased_class_name = classNames({
    "style_ordering-button_icon--is-reduced": !hide_descreased_price_icons && styleItem.selection_is_reduced,
    "style_ordering-button_icon--is-closeout": !hide_descreased_price_icons && !styleItem.selection_is_reduced && styleItem.selection_is_closeout,
    "style_ordering-button_icon--is-sale": !hide_descreased_price_icons && !styleItem.selection_is_reduced && !styleItem.selection_is_closeout && styleItem.selection_is_sale
  })

  return (
    <>
      <label className={className}>
        {children}
        {(styleItem.low_stock || price_decreased_text) && (
          <div className="style_ordering-button_icons">
            {price_decreased_text && (
              <span
                className={`style_ordering-button_icon ${price_descreased_class_name}`}
                title={price_decreased_text}
              ></span>
            )}
            {styleItem.low_stock && (
              <span
                className="style_ordering-button_icon style_ordering-button_icon--is-low-stock"
                title="Low Stock"
              ></span>
            )}
          </div>
        )}
        <input 
          onClick={onClick}
          onChange={onChange}
          type="radio"
          name={styleRef}
          value={styleItem.style_item_ref}
          checked={styleItem.selected}
          className="style_ordering-hidden-radio"
          aria-describedby={`${input_aria_described_by_id} ${stock_message_container_id}`}
          form='nonExistantForm'
        >
        </input>
      </label>
      <p id={input_aria_described_by_id} className="d-none">{!styleItem.valid &&"Please change other selections to make this option orderable"}</p>
    </>
  );
}
